import { useDictionaryContext } from 'application/contexts/DictionaryContext';
import { usePageContext } from 'application/contexts/PageContext';
import { useSiteContext } from 'application/contexts/SiteContext';
import { DocumentPage } from 'designsystem/components/5-templates/DocumentPage';
import { CludoLang } from 'features/Layouts/Layout/Vendors/Cludo/cludoHelpers';
import { AsideFeature } from 'features/Modules/Aside';
import { ModuleFeature } from 'features/Modules/DynamicModule';
import { LinkFeature } from 'features/Modules/Link';
import { RichTextFeature } from 'features/Modules/RichText';
import { convertForRichTextFeature } from 'features/Modules/RichText/richTextFeatureAdapter';
import { TopBannerFeature } from 'features/Modules/TopBanner';
import { fireAdobeEvent } from 'helpers/adobeEvent';
import Head from 'next/head';
import { useRouter } from 'next/router';

export const DocumentPageFeature: React.FC<Content.DocumentPage> = ({ properties, additionalTop, additionalPageContent }) => {
	const { asideContent, heading, teaser, documentId, documentPurpose, downloadLinks, links, notice, bannerContent } = properties ?? {};
	const dictionary = useDictionaryContext();
	const siteContext = useSiteContext();
	const pageContext = usePageContext();
	const router = useRouter();
	const lang = router.locale.split('-')[0] as CludoLang;

	const documentItems = [
		{
			label: dictionary.getDocument('DocumentId'),
			value: <p>{documentId}</p>,
		},
		{
			label: dictionary.getDocument('DocumentPurpose'),
			value: documentPurpose && <RichTextFeature content={convertForRichTextFeature(documentPurpose.markup)} />,
			links: [
				...[
					...(downloadLinks?.length > 0
						? downloadLinks.map((link, i) => (
								<LinkFeature key={i} {...link} callback={() => fireAdobeEvent('form_download', { name: link.title })} />
						  ))
						: []),
				],
				...[...(links?.length > 0 ? links.map((link, i) => <LinkFeature key={i} {...link} />) : [])],
			],
		},
		{
			label: notice ? dictionary.getLabel('Notice') : '',
			value: <p>{notice ? dictionary.getDocument('DocumentNotice') : ''}</p>,
		},
	];

	return (
		<>
			<Head>
				<meta name="ArticleId" content={documentId} />
				<meta name="ArticleTypes" content="Document" />
				<meta name="ArticleGroupId" content={`${siteContext.theme}-${pageContext.parent?.id}-${lang}`} />
			</Head>
			<DocumentPage
				additionalTop={additionalTop}
				additionalPageContent={additionalPageContent}
				heading={heading}
				teaser={teaser}
				documentItems={documentItems}
				topBanner={bannerContent?.items?.length > 0 && <TopBannerFeature bannerContent={bannerContent} />}
				aside={
					<AsideFeature>
						{asideContent?.items?.map((pageSection, index) => (
							<ModuleFeature key={index} contentModule={pageSection} />
						))}
					</AsideFeature>
				}
			/>
		</>
	);
};
